<template>
  <div class="inspector" :class="{ expanded: expanded }" :style="{ top: `${top}px`, left: `${left}px` }">
    <div class="inspector-heading" @mousedown.self="mousedown" @touchstart.self="touchstart">
      情報
      <a class="inspector-toggle" href="#" @click.prevent="toggle"></a>
    </div>
    <div class="inspector-body">
      <div v-if="expanded" class="inspector-data">
        <template v-if="item && item.config.type == 'room'">
          <div class="inspector-image">
            <div v-if="item.config.texture_url" class="inspector-texture" :style="{ backgroundImage: `url(${item.config.texture_url})` }"></div>
          </div>
          <div v-if="item.config.label" class="inspector-label">{{ item.config.label }}</div>
          <div class="inspector-width"><span>横</span><span>：</span><span>{{ numberFormat(item.width || 1820) }}</span><span>mm</span></div>
          <div class="inspector-height"><span>縦</span><span>：</span><span>{{ numberFormat(item.height || 1820) }}</span><span>mm</span></div>
        </template>
        <template v-else-if="item && item.config.type != 'room'">
          <div class="inspector-image"><img :src="useSvg() ? item.config.svg_url : item.config.img_url"></div>
          <div class="inspector-label">{{ item.config.label }}</div>
          <div class="inspector-makertext"><span>メーカー</span>{{ item.config.catalog.maker }}</div>
          <div class="inspector-width"><span>横</span><span>：</span><span>{{ numberFormat(item.config.catalog.width) }}</span><span>mm</span></div>
          <div class="inspector-height"><span>縦</span><span>：</span><span>{{ numberFormat(item.config.catalog.height) }}</span><span>mm</span></div>
          <div v-if="item.config.catalog.price" class="inspector-price"><span>価格</span><span>：</span><span>{{ numberFormat(item.config.catalog.price * 0.0001, '0,0.[00]') }}</span><span>万円</span></div>
          <div class="inspector-infotext">{{ item.config.catalog.info }}</div>
          <div v-if="item.config.catalog.url" class="inspector-makerlink"><a :href="item.config.catalog.url" target="_blank">メーカーサイト</a></div>
        </template>
        <template v-else>
          <div class="inspector-image"></div>
          <div class="inspector-label"></div>
          <div class="inspector-makertext"><span>メーカー</span></div>
          <div class="inspector-width"><span>横</span><span>：</span><span></span><span>mm</span></div>
          <div class="inspector-height"><span>縦</span><span>：</span><span></span><span>mm</span></div>
          <div class="inspector-price"><span>価格</span><span>：</span><span></span><span>万円</span></div>
          <div class="inspector-infotext"></div>
          <div class="inspector-makerlink"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import helpers from '../helpers'

export default {
  mixins: [helpers],
  data() {
    return {
      expanded: true,
      left: 9,
      top: 64,
      grabbing: null,
    }
  },
  computed: {
    ...mapState({
      item: state => state.editor.inspectItem,
    }),
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    mousedown(e) {
      let rect = this.$el.getBoundingClientRect()
      this.grabbing = {
        left: e.pageX - rect.left,
        top: e.pageY - rect.top,
      }
      window.addEventListener('mousemove', this.mousemove)
      window.addEventListener('mouseup', this.mouseup)
    },
    mouseup(e) {
      this.grabbing = null
      window.removeEventListener('mousemove', this.mousemove)
      window.removeEventListener('mouseup', this.mouseup)
    },
    mousemove(e) {
      if (this.grabbing != null) {
        let rect = this.$el.parentNode.getBoundingClientRect()
        this.left = e.pageX - this.grabbing.left - rect.left
        this.top = e.pageY - this.grabbing.top - rect.top
      }
    },
    touchstart(e) {
      let rect = this.$el.getBoundingClientRect()
      this.grabbing = {
        left: e.touches[0].clientX - rect.x,
        top: e.touches[0].clientY - rect.y,
      }
      window.addEventListener('touchmove', this.touchmove, { passive: false })
      window.addEventListener('touchend', this.touchend)
    },
    touchend(e) {
      this.grabbing = null
      window.removeEventListener('touchmove', this.touchmove, { passive: false })
      window.removeEventListener('touchend', this.touchend)
    },
    touchmove(e) {
      if (this.grabbing != null) {
        e.preventDefault()
        let rect = this.$el.parentNode.getBoundingClientRect()
        this.left = e.touches[0].clientX - this.grabbing.left - rect.left
        this.top = e.touches[0].clientY - this.grabbing.top - rect.top
      }
    },
    toggle() {
      this.expanded = !this.expanded
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../sass/bootstrap";
.inspector {
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 195px;
  max-height: 384px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 1.5px 1.5px 8px rgba(0, 0, 0, .2);
  z-index: 10;
}
.inspector-heading {
  flex: 0 0 30px;
  display: flex;
  align-items: center;
  margin: 3px;
  padding: 0 7px 0 10px;
  @include gradient-x(#9E7743, #895A3D);
  border-radius: 6px;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 7px;
  line-height: 1;
  transition: .2s ease border-radius;
  .expanded & {
    margin: 3px 3px 2px;
    border-radius: 6px 6px 0 0;
  }
}
// .inspector-title {
// }
.inspector-toggle {
  margin-left: auto;
  width: 18px;
  height: 18px;
  border-radius: 1px;
  background-color: #875f35;
  background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2018%2018%22%20width%3D%2218%22%20height%3D%2218%22%3E%3Cpath%20d%3D%22M.5%2C16.5a.88.88%2C0%2C0%2C0%2C1%2C1h15a.88.88%2C0%2C0%2C0%2C1-1V1.5a.88.88%2C0%2C0%2C0-1-1H1.5a.88.88%2C0%2C0%2C0-1%2C1Z%22%20style%3D%22fill%3Anone%22%2F%3E%3Cpath%20d%3D%22M1.5%2C17.5h15a.88.88%2C0%2C0%2C0%2C1-1V1.5a.88.88%2C0%2C0%2C0-1-1H1.5a.88.88%2C0%2C0%2C0-1%2C1v15A.88.88%2C0%2C0%2C0%2C1.5%2C17.5Z%22%20style%3D%22fill%3Anone%3Bstroke%3A%23fff%3Bstroke-linecap%3Asquare%3Bstroke-miterlimit%3A3%22%2F%3E%3Cpath%20d%3D%22M3.5%2C10v4h11V10Z%22%20style%3D%22fill%3A%23fde6c6%22%2F%3E%3Cpath%20d%3D%22M3.5%2C10h11v4H3.5Z%22%20style%3D%22fill%3Anone%3Bstroke%3A%237d6040%3Bstroke-linecap%3Asquare%3Bstroke-miterlimit%3A3%3Bstroke-width%3A0.800000011920929px%22%2F%3E%3Cpath%20d%3D%22M15.5%2C1.5H2.5a.88.88%2C0%2C0%2C0-1%2C1v13a.88.88%2C0%2C0%2C0%2C1%2C1h13a.88.88%2C0%2C0%2C0%2C1-1V2.5A.88.88%2C0%2C0%2C0%2C15.5%2C1.5Z%22%20style%3D%22fill%3Anone%3Bstroke%3A%23795c3e%3Bstroke-linecap%3Asquare%3Bstroke-miterlimit%3A3%22%2F%3E%3C%2Fsvg%3E');
  // background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2018%2018%22%20width%3D%2218%22%20height%3D%2218%22%3E%3Cpath%20style%3D%22fill%3A%23fff%22%20d%3D%22M.5%2C16.5a.88.88%2C0%2C0%2C0%2C1%2C1h15a.88.88%2C0%2C0%2C0%2C1-1V1.5a.88.88%2C0%2C0%2C0-1-1H1.5a.88.88%2C0%2C0%2C0-1%2C1Z%22%2F%3E%3Cpath%20style%3D%22fill%3Anone%3Bstroke%3A%23fff%3Bstroke-linecap%3Asquare%3Bstroke-miterlimit%3A3%22%20d%3D%22M1.5%2C17.5h15a.88.88%2C0%2C0%2C0%2C1-1V1.5a.88.88%2C0%2C0%2C0-1-1H1.5a.88.88%2C0%2C0%2C0-1%2C1v15A.88.88%2C0%2C0%2C0%2C1.5%2C17.5Z%22%2F%3E%3Cpath%20style%3D%22fill%3A%23875f35%22%20d%3D%22M2.5%2C16.5h13a.88.88%2C0%2C0%2C0%2C1-1V2.5a.88.88%2C0%2C0%2C0-1-1H2.5a.88.88%2C0%2C0%2C0-1%2C1v13A.88.88%2C0%2C0%2C0%2C2.5%2C16.5Z%22%2F%3E%3Cpath%20style%3D%22fill%3A%23fde6c6%22%20d%3D%22M3.5%2C10v4h11V10Z%22%2F%3E%3Cpath%20style%3D%22fill%3Anone%3Bstroke%3A%237d6040%3Bstroke-linecap%3Asquare%3Bstroke-miterlimit%3A3%3Bstroke-width%3A0.800000011920929px%22%20d%3D%22M3.5%2C10h11v4H3.5Z%22%2F%3E%3Cpath%20style%3D%22fill%3Anone%3Bstroke%3A%23795c3e%3Bstroke-linecap%3Asquare%3Bstroke-miterlimit%3A3%22%20d%3D%22M15.5%2C1.5H2.5a.88.88%2C0%2C0%2C0-1%2C1v13a.88.88%2C0%2C0%2C0%2C1%2C1h13a.88.88%2C0%2C0%2C0%2C1-1V2.5A.88.88%2C0%2C0%2C0%2C15.5%2C1.5Z%22%2F%3E%3C%2Fsvg%3E');
  transition: .5s ease background-color;
  &:hover {
    background-color: #D7AF7B;
  }
}
.inspector-body {
  height: 0;
  transition: .1s ease height;
  .expanded & {
    height: 354px;
  }
}
.inspector-data {
  border-top: 2px solid #e8e8e8;
  padding: 9px 17px;
}
.inspector-image {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  width: 160px;
  height: 90px;
  img {
    max-width: 160px;
    max-height: 90px;
  }
}
.inspector-texture {
  width: 84px;
  height: 84px;
  border: 2px solid #999;
}
.inspector-label {
  margin-bottom: 3px;
  font-size: 12px;
  font-weight: bold;
  white-space: pre-wrap;
}
.inspector-makertext {
  margin-bottom: 5px;
  font-size: 12px;
  span {
    display: inline-block;
    margin-right: 3px;
    padding: 0 5px;
    height: 12px;
    background-color: #999;
    border-radius: 6px;
    font-size: 10px;
    color: #fff;
    text-align: center;
    line-height: 12px;
  }
}
.inspector-width, .inspector-height, .inspector-price {
  display: flex;
  align-items: baseline;
  margin-bottom: 5px;
  font-size: 12px;
  span:nth-child(1) { flex: 0 0 2em; }
  span:nth-child(2) { flex: 0 0 1em; }
  span:nth-child(3) { flex: 1 1 auto; margin-right: 5px; text-align: right; border-bottom: 1px solid #ccc; }
  span:nth-child(4) { flex: 0 0 2em; }
}
.inspector-price {
  margin-bottom: 10px;
}
.inspector-infotext {
  margin-bottom: 10px;
  height: 64px;
  border: 1px solid #ccc;
  overflow: auto;
  font-size: 12px;
  line-height: calc(64px / 3 - 1px);
}
.inspector-makerlink {
  text-align: right;
  a {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 7px;
    height: 14px;
    border-radius: 7px;
    @include transition($btn-transition);
    @include button-variant($primary, $primary, #A4CB3F, #A4CB3F, #A4CB3F, #A4CB3F);
    color: #fff;
    font-size: 10px;
    font-weight: bold;
    text-decoration: none;
    &:before {
      content: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210px%22%20height%3D%228px%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20fill%3D%22%23fff%22%20d%3D%22M2%2C-0%20L2%2C2%20L-0%2C2%20L-0%2C8%20L8%2C8%20L8%2C6%20L10%2C6%20L10%2C-0%20L2%2C-0%20ZM2%2C3%20L1%2C3%20L1%2C7%20L7%2C7%20L7%2C6%20L2%2C6%20L2%2C3%20Z%22%2F%3E%3C%2Fsvg%3E');
      margin-right: 2px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// assets/js/components/Inspector.vue